import { Link } from 'react-router-dom';
import { Footer } from '@/components/Footer';

export default function CguClients() {
    return (
        <div className="min-h-screen bg-slate-50 flex flex-col">
            <div className="flex-1 max-w-3xl mx-auto px-4 py-12 w-full">
                <Link to="/" className="text-emerald-600 text-sm font-medium hover:underline mb-6 inline-block">&larr; Retour à l'accueil</Link>
                <h1 className="text-3xl font-bold text-slate-900 mb-2">Conditions Générales d'Utilisation</h1>
                <p className="text-emerald-600 font-medium mb-8">Utilisateurs Clients</p>

                <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-slate-100 space-y-6 text-sm text-slate-600 leading-relaxed">
                    <p className="text-slate-500">Dernière mise à jour : 28 février 2026</p>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">1. Objet</h2>
                        <p>Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation de la plateforme FidelRun par les utilisateurs clients. En créant un compte client, vous acceptez sans réserve les présentes CGU.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">2. Inscription et compte</h2>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>L'inscription est gratuite pour les clients.</li>
                            <li>Vous devez fournir des informations exactes et à jour lors de votre inscription (nom, email, mot de passe).</li>
                            <li>Vous êtes responsable de la confidentialité de vos identifiants de connexion.</li>
                            <li>Un seul compte par adresse email est autorisé.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">3. Programmes de fidélité</h2>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>En tant que client, vous pouvez rejoindre les programmes de fidélité des commerçants partenaires via un QR code ou un lien de partage.</li>
                            <li>Les points, tampons et récompenses sont gérés par chaque commerçant selon ses propres conditions.</li>
                            <li>FidelRun ne garantit pas la valeur, la disponibilité ou les conditions des récompenses proposées par les commerçants.</li>
                            <li>Vous pouvez vous désabonner d'un programme de fidélité à tout moment depuis votre wallet.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">4. Données personnelles et consentement RGPD</h2>
                        <p>Lors de votre inscription, vous êtes invité à cocher la case suivante :</p>
                        <div className="bg-slate-50 rounded-xl p-4 mt-2 border border-slate-200 italic">
                            "J'accepte que mes données personnelles soient utilisées dans le cadre du programme de fidélité, conformément au RGPD."
                        </div>
                        <p className="mt-3">En cochant cette case, vous acceptez que :</p>
                        <ul className="list-disc pl-5 mt-2 space-y-2">
                            <li>Vos données personnelles soient partagées avec les commerçants dont vous rejoignez les programmes de fidélité.</li>
                            <li>Les commerçants puissent utiliser vos données pour vous envoyer des <strong>campagnes marketing</strong> (promotions, offres, notifications push) dans le cadre de leur programme de fidélité.</li>
                        </ul>
                        <p className="mt-2">Pour plus de détails, consultez notre <Link to="/confidentialite" className="text-emerald-600 hover:underline">Politique de Confidentialité</Link>.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">5. QR Code personnel</h2>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>À l'inscription, un QR code unique vous est attribué.</li>
                            <li>Ce QR code vous identifie auprès des commerçants pour la validation de vos achats et l'attribution de vos points/tampons.</li>
                            <li>Vous ne devez pas partager votre QR code avec d'autres personnes.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">6. Notifications</h2>
                        <p>En activant les notifications push, vous acceptez de recevoir des communications des commerçants dont vous avez rejoint les programmes (promotions, rappels, récompenses). Vous pouvez désactiver les notifications à tout moment depuis les paramètres de votre navigateur.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">7. Comportement de l'utilisateur</h2>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>Toute tentative de fraude (scan abusif, usurpation d'identité, manipulation de points/tampons) entraînera la suspension ou la suppression de votre compte.</li>
                            <li>FidelRun se réserve le droit de limiter le nombre de scans par jour pour prévenir les abus.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">8. Suppression du compte</h2>
                        <p>Vous pouvez demander la suppression de votre compte à tout moment en contactant <a href="mailto:digirun974@gmail.com" className="text-emerald-600 hover:underline">digirun974@gmail.com</a>. La suppression entraîne la perte de tous vos points, tampons et récompenses en cours.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">9. Limitation de responsabilité</h2>
                        <p>FidelRun est un outil technique de gestion de programmes de fidélité. FidelRun ne saurait être tenu responsable :</p>
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                            <li>Des récompenses proposées par les commerçants.</li>
                            <li>De l'interruption temporaire du service pour maintenance.</li>
                            <li>De l'utilisation de vos données par les commerçants (voir <Link to="/confidentialite" className="text-emerald-600 hover:underline">Politique de Confidentialité</Link>).</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">10. Droit applicable</h2>
                        <p>Les présentes CGU sont régies par le droit français. Tout litige sera soumis aux tribunaux compétents de Saint-Denis de La Réunion.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">11. Contact</h2>
                        <p>SARL DEALRUN — <a href="mailto:digirun974@gmail.com" className="text-emerald-600 hover:underline">digirun974@gmail.com</a> — <a href="tel:0693463628" className="text-emerald-600 hover:underline">06 93 46 36 28</a></p>
                    </section>
                </div>
            </div>
            <Footer />
        </div>
    );
}
